export const baseUrlHelper = {
  methods: {
    urlHelper(url, id, slug = null, stub = '%listing%') {
      const replacedPart = url?.replace(stub, id);

      if (slug) {
        return `${replacedPart}/${slug}`;
      }

      return replacedPart;
    }
  }
};